import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession, signOut } from '../lib/auth';
import { User, LogOut, Settings, ChevronDown, Loader } from 'lucide-react';

function UserProfile() {
  const { data: session, isPending } = useSession();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      await signOut();
      setIsDropdownOpen(false);
    } catch (error) {
      console.error('Sign out failed:', error);
    } finally {
      setIsSigningOut(false);
    }
  };

  if (isPending) {
    return (
      <div className="flex items-center space-x-2">
        <Loader className="animate-spin text-gray-500" size={16} />
        <span className="text-sm text-gray-500">Loading...</span>
      </div>
    );
  }

  if (!session?.user) {
    return null;
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
          {session.user.image ? (
            <img
              src={session.user.image}
              alt={session.user.name || 'User'}
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <User className="text-white" size={16} />
          )}
        </div>
        <div className="hidden sm:block">
          <p className="text-sm font-medium text-gray-700">
            {session.user.name || 'User'}
          </p>
        </div>
        <ChevronDown 
          className={`text-gray-500 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} 
          size={16} 
        />
      </button>

      {isDropdownOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsDropdownOpen(false)}
          />
          
          {/* Dropdown Menu */}
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
            <div className="px-4 py-3 border-b border-gray-200">
              <p className="font-medium text-gray-800">{session.user.name || 'User'}</p>
              <p className="text-sm text-gray-500">{session.user.email}</p>
            </div>

            <div className="py-2">
              <button
                onClick={() => {
                  setIsDropdownOpen(false);
                  navigate('/dashboard');
                }}
                className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
              >
                <Settings size={16} />
                <span>My Dashboard</span>
              </button>

              <button
                onClick={handleSignOut}
                disabled={isSigningOut}
                className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center space-x-2 disabled:opacity-50"
              >
                {isSigningOut ? (
                  <Loader className="animate-spin" size={16} />
                ) : (
                  <LogOut size={16} />
                )}
                <span>{isSigningOut ? 'Signing out...' : 'Sign Out'}</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UserProfile;